import React from 'react';
//import { Dropdown } from '../elements/Dropdown';
import Select from '../elements/Select';
import { FormLabel } from '../elements/FormLabel';
import styled from 'styled-components';

export class TicketTypeSelector extends React.Component {
	state = { ticketType: '' };

	selectType = event => {
		const { target } = event;
		this.setState({ ticketType: target.value });
	};

	onSelect = item => {
		this.props.onSelectTicket(item);
	};

	render() {
		const { types = [], texts } = this.props;

		const ticketTypes = types.map(t => ({ ...t, id: t.id ?? t.name }));
		const hasTypes = types.length > 0;
		const onSelect = hasTypes ? this.onSelect : () => null;
		const items = hasTypes ? ticketTypes : [{ title: "Välj resa för att se biljettyper", id: "0" }];

		return (
			<>
				<FormLabel className="h3" htmlFor="TicketTypeDropdown">
					{texts.private.buyticketpage.tickettypeoptions.tickettype}
				</FormLabel>

				<Select
					id="TicketTypeDropdown"
					disabled={!hasTypes}
					onSelect={onSelect}
					items={items}
				/>

				{/*<Dropdown
					id="TicketTypeDropdown"
					onSelect={this.onSelect}
					items={types}
					renderItem={item => (
						<>
							<p style={{ margin: '0' }}>{item.title}</p>
							<div style={{ fontSize: '.8em' }}>
								<i>{item.description}</i>
							</div>
						</>
					)}
				/><*/}
			</>
		);
	}
}

export const H2 = styled.h2`
	font-size: 24px;
`;

